const StrictMode = () => {
    return (
        <div className="demo-container">
            <div className="demo-box">
                <div className="lead">Strict Mode</div>
                <code>https://reactjs.org/docs/strict-mode.html : Check here very well explained</code>
            </div>
        </div>
    )
}

export default StrictMode